<template>
    <v-container class="subheading">
      <v-layout text-xs-center wrap>
        <v-spacer></v-spacer>
        <v-flex md7>
          <div class="headline mb-0">Recent Posts</div>
          <br>
          <RecentPosts/>
        </v-flex>

        <v-spacer></v-spacer>
        <v-flex md3>
          <h2 class="headline mb-0">Recent News</h2>
          <br>
          <RecentNews/>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-container>
</template>

<script>
import RecentNews from "./RecentNews";
import RecentPosts from "./RecentPosts";

export default {
  name: 'Home',
  components: {
    RecentPosts,
    RecentNews,
  },
  data: function() {
    return {
      //
    };
  }
};
</script>
